import React from 'react';
import { StyleSheet, View } from 'react-native';
import { BodyText, theme, useResponsive } from '@sweetgreen/garnish';

import type { useOrganizationLinksFooterContentfulData } from '../hooks';
import { SupportedOrganizationLinkFooterActions } from '../utils';
import { OrganizationLinksFooterLink } from './OrganizationLinksFooterLink';
import { OrganizationLinksFooterLinkKustomer } from './OrganizationLinksFooterLinkKustomer';

export const OrganizationLinksFooterSection = (props: SectionProps) => {
  const { section } = props;

  const { match } = useResponsive();

  return (
    <View style={match([styles.xsMargin, undefined])}>
      <BodyText style={styles.title}>{section.name}</BodyText>
      {section.links.map((link) => {
        const OrganizationLink = getOrganizationLink(link);

        return <OrganizationLink key={link.label} link={link} />;
      })}
    </View>
  );
};

// ─── Utils ───────────────────────────────────────────────────────────────

function getOrganizationLink(link: SectionProps['section']['links'][0]) {
  switch (link.specialHandler) {
    case SupportedOrganizationLinkFooterActions.Kustomer:
      return OrganizationLinksFooterLinkKustomer;
    default:
      return OrganizationLinksFooterLink;
  }
}

// ─── Types ───────────────────────────────────────────────────────────────

type SectionProps = {
  readonly section: ReturnType<
    typeof useOrganizationLinksFooterContentfulData
  >['contentfulFooter']['sections'][0];
};

// ─── Styles ──────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  title: {
    marginBottom: theme.spacing['4'],
    textTransform: 'uppercase',
  },
  xsMargin: {
    marginBottom: theme.spacing['4'],
  },
});
